import React, { useContext } from 'react';
import Link from 'next/link';
import { Trans } from '@lingui/react';
import LanguageContext from '@lib/contexts/languageContext';
import { Instructor, Term } from '@gql/generated';
import Button from '@components/buttons';
import { LinkStyleMetadata } from '@components/links';
import InstructorModal from '@organisms/modals/InstructorModal';

const Separator = props => {
  if (props.index + 1 < props.length - 1) {
    return <>,&nbsp;</>;
  } else {
    return (
      <React.Fragment>
        {' '}
        <Trans id="metadata.and" message={'and'} />{' '}
      </React.Fragment>
    );
  }
};

type Props = {
  instructors: Instructor[];
  openInVideos?: boolean;
  genre?: string;
  genreSlug?: string;
  primaryStyle?: Term;
};
const GenreInstructorMetadata = (props: Props) => {
  const locale = useContext(LanguageContext);
  const [first, ...rest] = props.instructors;

  let firstInstructor = null;
  if (first) {
    if (props.openInVideos) {
      const asPath = `/${locale}/videos/genres/all?instructors=${first.slug}`;
      firstInstructor = (
        // ISSUE WITH THE [GENRE] PAGE, FRONTEND ROUTING WITH PARAMS DOES NOT DETECT PARAMS...
        <Link href={asPath} shallow={false} legacyBehavior>
          <Button appearance="link" href={asPath}>
            {first.name}
          </Button>
        </Link>
      );
    } else {
      firstInstructor = (
        <InstructorModal slug={first.slug}>
          {handleOpenModal => (
            <Button
              appearance="link"
              onClick={handleOpenModal}
              data-testid="GenreInstructorMetadata--Name"
            >
              {first.name}
            </Button>
          )}
        </InstructorModal>
      );
    }
  }

  let typeContent = null;
  if (props.primaryStyle) {
    typeContent = (
      <>
        <Link
          href={{
            pathname: `/${locale}/videos/genres/all`,
            query: { styles: props.primaryStyle?.slug },
          }}
          legacyBehavior>
          <LinkStyleMetadata bold>
            {props.primaryStyle?.name}
            {` `}
          </LinkStyleMetadata>
        </Link>
        <Trans id="metadata.with" message={'med'} />
        {` `}
      </>
    );
  } else if (props.genre) {
    typeContent = (
      <>
        <Link href={`/${locale}/videos/genres/${props.genreSlug}`} legacyBehavior>
          <LinkStyleMetadata bold>
            {props.genre}
            {` `}
          </LinkStyleMetadata>
        </Link>
        <Trans id="metadata.with" message={'med'} />
        {` `}
      </>
    );
  }

  return (
    <>
      {typeContent}
      {firstInstructor}
      {rest &&
        rest.length < 3 &&
        rest.map((instructor, index) => (
          <InstructorModal key={index} slug={instructor.slug}>
            {handleOpenModal => (
              <React.Fragment>
                <Separator index={index} length={rest.length} />
                <Button appearance="link" onClick={handleOpenModal}>
                  {instructor.name}
                </Button>
              </React.Fragment>
            )}
          </InstructorModal>
        ))}

      {rest && rest.length >= 3 && (
        <React.Fragment>
          {' '}
          <Trans id="metadata.and" message={'and'} /> {rest.length}{' '}
          <Trans id="metadata.more" message={'more'} />
        </React.Fragment>
      )}
    </>
  );
};

export default GenreInstructorMetadata;
